import './cookie-banner.js';
import { supabase } from './lib/supabase.js';

const form = document.getElementById('loginForm');
const errorMsg = document.getElementById('errorMsg');
const submitBtn = document.getElementById('submitBtn');

// Se già loggato, vai direttamente all'app
supabase.auth.getSession().then(({ data }) => {
  if (data.session) window.location.href = '/app.html';
});

form.addEventListener('submit', async (e) => {
  e.preventDefault();
  errorMsg.classList.remove('visible');
  submitBtn.disabled = true;
  submitBtn.textContent = 'Signing in...';

  const email = document.getElementById('email').value.trim();
  const password = document.getElementById('password').value;

  const { error } = await supabase.auth.signInWithPassword({ email, password });

  if (error) {
    errorMsg.textContent = error.message === 'Invalid login credentials'
      ? 'Invalid email or password.'
      : error.message;
    errorMsg.classList.add('visible');
    submitBtn.disabled = false;
    submitBtn.textContent = 'Sign In';
    return;
  }

  window.location.href = '/app.html';
});

// Forgot password
document.getElementById('forgotLink')?.addEventListener('click', async (e) => {
  e.preventDefault();
  const email = document.getElementById('email').value.trim();
  if (!email) {
    errorMsg.textContent = 'Enter your email first, then click Forgot password.';
    errorMsg.classList.add('visible');
    return;
  }
  const redirectTo = `${window.location.origin}/reset-password.html`;
  const { error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo });
  if (error) {
    errorMsg.textContent = error.message;
    errorMsg.classList.add('visible');
  } else {
    errorMsg.style.color = '#26a69a';
    errorMsg.textContent = 'Reset link sent — check your email.';
    errorMsg.classList.add('visible');
  }
});
